import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { ClockHistory } from 'react-bootstrap-icons';

import StationLinker from './StationLinker.js';

import { formatTimestamp } from '../lib/formatHelpers.js';

const FloodEventHistoryButton = function({ stationId, urlSlug, floodEventCount, earliestFloodEventTime }) {

	// Safety guard
	if(!floodEventCount || !stationId || !earliestFloodEventTime) {
		return null;
	}


	return <Row>
		<Col xs={12}>
			<span style={{fontSize: "0.8em"}}>
				We have <b><i>{floodEventCount}</i></b> historical flood event records available for this station.<br />These date back to <b><i>{formatTimestamp(earliestFloodEventTime)}</i></b>.<br />
				<StationLinker stationId={stationId} urlSlug={urlSlug} isHistoricalLink={true}>
					<Button variant="dark" size="sm"><ClockHistory /> View historical records</Button>
				</StationLinker>
			</span>
		</Col>
	</Row>;

	/*{(station && station.metadata && station.metadata.floodEventCount && station.metadata.floodEventCount > 0) ? <Row>
							<Col xs={12}>
								<span style={{fontSize: "0.8em"}}>
									We have <b><i>{station.metadata.floodEventCount}</i></b> historical flood event records available for this station.<br />These date back to <b><i>{formatTimestamp(station.metadata.earliestFloodEventTime)}</i></b>.<br />
									<StationLinker stationId={station.stationId}>
										<Button variant="dark" size="sm"><ClockHistory /> View historical records</Button>
									</StationLinker>
								</span>
							</Col>
						</Row> : null}*/
}

export default FloodEventHistoryButton;